import angular from 'angular';
import applicationWidgets from './applicationWidgets';

export default angular
  .module('components.applicationWidgets', [])
  .component('applicationWidgets', applicationWidgets).name;
